import Component from '@/store/Component.js'

export default class Render extends Component {
  static create (options = {}) {
    return {
      kind: 'render',
      vueComponent: options.vueComponent
    }
  }
}
